module.exports = "/_next/static/images/f424c8bd437922425e29ed7583fae8e3-women-lg.png.webp";